import React from 'react';
import Template from '../../components/expertise/template'

const Commercial = ()=> {
    return <Template expertise="commercial" id={0} />
}
export default Commercial